import { useSelector } from 'react-redux';
import usePrefersDark from '../../../shared/hooks/usePrefersDark';

/** Whether Build renders dark: the per-user Appearance preference, with
 * 'system' following the OS colour scheme. The org skin's darknessMode used to
 * be the implicit default; it no longer takes part. */
const useBuildIsDark = () => {
  const appearance = useSelector((state) => state.calendar.ui.appearance);
  const prefersDark = usePrefersDark();
  return appearance === 'dark' || (appearance === 'system' && prefersDark);
};

export default useBuildIsDark;
